import type { LinearCstic } from "../../../models";
import type { NamingProps } from "./KUEMUnitConfigurationPage";

export class CsticNamingHelper {
  constructor(private cstics: Record<string, LinearCstic>) {}

  updateNames(csticName: string, { label, value, info, description }: NamingProps) {
    const cstic = this.cstics[csticName];
    if (!cstic) {
      return;
    }
    if (label) {
      cstic.label = label;
    }
    if (value) {
      cstic.values.forEach((val) => {
        if (value.label) {
          val.label = value.label(val.value);
        }
        if (value.imageUrl) {
          val.imageUrl = value.imageUrl(val.value);
        }
      });
    }
    if (info) {
      cstic.info = info;
    }
    if (description) {
      cstic.description = description;
    }
  }
}
